import React from "react";
import { Icon } from "@iconify/react";
import { useStore } from "../../hooks/useStore";

const StoreFilters = () => {
  const { 
    selectedCategory, 
    searchTerm, 
    categories, 
    setCategory, 
    setSearch 
  } = useStore();

  const handleCategoryChange = (category) => {
    setCategory(category);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className="card radius-12 mb-24">
      <div className="card-body p-24">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="d-flex align-items-center gap-3">
              <h6 className="text-lg mb-0">Filtros da Loja</h6>
              <span className="badge bg-primary-50 text-primary-600 px-12 py-6 text-sm">
                {categories.length - 1} categorias
              </span>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-flex align-items-center gap-3 justify-content-lg-end">
              <div className="position-relative">
                <input
                  type="text"
                  placeholder="Buscar produtos..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="form-control ps-40 pe-16 py-12 radius-8 border-neutral-200"
                  style={{ minWidth: "280px" }}
                />
                <Icon
                  icon="solar:magnifer-linear"
                  className="position-absolute top-50 start-0 translate-middle-y ms-12 text-secondary-light"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Filtros de Categoria */}
        <div className="mt-20">
          <div className="d-flex flex-wrap gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => handleCategoryChange(category)}
                className={`btn btn-sm px-16 py-8 radius-8 border-0 fw-medium ${
                  selectedCategory === category
                    ? "bg-primary-600 text-white"
                    : "bg-neutral-100 text-secondary-light hover-bg-primary-50 hover-text-primary-600"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreFilters;